import script from "./Expansion.vue?vue&type=script&lang=ts&setup=true"
export * from "./Expansion.vue?vue&type=script&lang=ts&setup=true"

import "./Expansion.vue?vue&type=style&index=0&id=211097fc&lang=scss"

const __exports__ = script;

export default __exports__